/**
 * Bitrix Messenger
 * Recent list constants
 *
 * @package bitrix
 * @subpackage im
 * @copyright 2001-2020 Bitrix
 */

export const ChatTypes = {
	chat: 'chat',
	open: 'open',
	user: 'user',
	notification: 'notification'
};

export const TemplateTypes = {
	item: 'item',
	placeholder: 'placeholder'
}

export const RecentSection = {
	general: 'general',
	pinned: 'pinned'
}

export const MessageStatus = {
	received: 'received',
	delivered: 'delivered',
	error: 'error'
}